import {
	Box,
	Container,
	SimpleGrid,
	Stack,
	IconButton,
	Heading,
	Text,
	Flex,
	HStack,
	Button,
	useColorModeValue,
} from "@chakra-ui/react";
import { BsGithub } from "react-icons/bs";

import { MdPhone, MdEmail, MdLocationOn } from "react-icons/md";
import { FaLinkedin } from "react-icons/fa";

export default function Contact() {
	return (
		<>
			<Container maxW={"6xl"}>
				<Stack
					textAlign={"center"}
					align={"center"}
					spacing={{ base: 8, md: 10 }}
					pt={{ base: 10, md: 18 }}
				>
					<Heading
						fontWeight={600}
						fontSize={{ base: "xl", sm: "2xl", md: "4xl" }}
						lineHeight={"110%"}
					>
						<Text as={"span"} color={"blue.400"}>
							Contact
						</Text>
					</Heading>

					<Flex w={"full"}></Flex>
				</Stack>
			</Container>
			<Box
				width={"full"}
				bg={useColorModeValue("gray.50", "gray.900")}
				color={useColorModeValue("gray.700", "gray.200")}
				pb={{ base: 16, md: 26 }}
			>
				<Container as={Stack} maxW={"6xl"} py={10}>
					<SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={8}>
						<Stack align={"center"}>
							<Button
								size="md"
								height="48px"
								width="250px"
								variant="ghost"
								_hover={{ border: "2px solid #1C6FEB" }}
								leftIcon={<MdPhone color="#1970F1" size="22px" />}
								onClick={(e)=>{
									navigator.clipboard.writeText("+919588414323");
									alert("Copied");
								}}
							>
								+919588414323
							</Button>
						</Stack>
						<Stack align={"center"}>
							<Button
								size="md"
								height="48px"
								width="250px"
								variant="ghost"
								_hover={{ border: "2px solid #1C6FEB" }}
								leftIcon={<MdEmail color="#1970F1" size="22px" />}
								onClick={(e)=>{
									navigator.clipboard.writeText("abhijitaher2022@gmail.com");
									alert("Copied");
								}}
							>
								abhijitaher2022@gmail.com
							</Button>
						</Stack>
						<Stack align={"center"}>
							<Button
								size="md"
								height="48px"
								width="250px"
								variant="ghost"
								_hover={{ border: "2px solid #1C6FEB" }}
								leftIcon={<MdLocationOn color="#1970F1" size="22px" />}
							>
								Maharashtra, India
							</Button>
						</Stack>
					</SimpleGrid>
				</Container>
				<HStack width="full" spacing={5} px={5} justify={"center"}>
					<IconButton
						aria-label="linkedin"
						variant="ghost"
						size="lg"
						isRound={true}
						_hover={{ bg: "#0D74FF" }}
						icon={<FaLinkedin size="28px" />}
						onClick={() => {
							window.open("https://www.linkedin.com/in/abhijitaher/", "_blank");
						}}
					/>
					<IconButton
						aria-label="github"
						variant="ghost"
						size="lg"
						isRound={true}
						_hover={{ bg: "#0D74FF" }}
						icon={<BsGithub size="28px" />}
						onClick={() => {
							window.open("https://github.com/AbhijitAher", "_blank");
						}}
					/>
				</HStack>
			</Box>
		</>
	);
}

/* 
email id, 
LinkedIn link, 
GitHub link, 
Medium link, 
Twitter link, 
location (state, country), 
phone number (optional)
Email id, LinkedIn and GitHub links are mandatory (remaining are good to have)
Please use only logos or only titles for links

*/
